// @material-ui
import { makeStyles } from '@material-ui/styles'

export const priceStyle = theme => ({
  root: {}
})

export const usePriceStyle = makeStyles(priceStyle)
